/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::b3c61250a84f619b4027771ee5c5ce69>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen global-side-navigation
 */
import { useCallback } from 'react';

import { useAnalyticsEvents as useAnalyticsNextEvents } from '@atlaskit/analytics-next';

import { EVENT_CHANNEL } from '../constants';

import type { AnalyticsEventAttributes, EventKey } from './analytics.types';
import createEventPayload from './create-event-payload';

export const useAnalyticsEvents = (): {
	fireEvent: <K extends EventKey>(
		eventKey: K,
		...params: undefined extends AnalyticsEventAttributes[K]
			? [param?: AnalyticsEventAttributes[K] | undefined]
			: [param: AnalyticsEventAttributes[K]]
	) => void;
} => {
	const { createAnalyticsEvent } = useAnalyticsNextEvents();
	const fireEvent = useCallback(
		<K extends EventKey>(...params: Parameters<typeof createEventPayload<K>>): void => {
			const event = createAnalyticsEvent(createEventPayload<K>(...params));
			event.fire(EVENT_CHANNEL);
		},
		[createAnalyticsEvent],
	) as <K extends EventKey>(
		eventKey: K,
		...params: undefined extends AnalyticsEventAttributes[K]
			? [param?: AnalyticsEventAttributes[K] | undefined]
			: [param: AnalyticsEventAttributes[K]]
	) => void;
	return {
		fireEvent,
	};
};
